<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
export let meta = {};
import uiStore from '../../utils/UIStore';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});
</script>


<div class="metadata">
    <h6>{uiTexts.ragMeta.title}</h6>
    <ul>
        {#if meta}
            {#each Object.entries(meta) as [key, value]}
                {#if value !== null && value !== undefined && value !== ""}
                    <li>
                        <span style="font-weight: bolder">
                            {key}:
                        </span>
                        {#if Array.isArray(value)}
                            {value.join(", ")}
                        {:else}
                            {value}
                        {/if}
                    </li>
                {/if}
            {/each}
        {/if}
    </ul>
</div>


<style>
    .metadata {
        border-left: #666666 solid;
        margin-top: 25px;
        font-size: smaller;
        color: #666666;
        padding-left: 20px;
    }

    .metadata ul {
        list-style: none;
    }

</style>